

export default class settingsRequest {
  constructor(service) {
    this.service = service;
  }

  getSettings$() {
    return this.service
      .fetch$({
        method: 'GET',
        url: '/settings',
      });
  }

  updateSettings$(settings) {
    return this.service
      .fetch$({
        method: 'PUT',
        url: '/settings',
        body: {
          ...settings,
        },
      });
  }
}
